import React, { useState } from "react";
import { getReseredTime } from "../../../../../../functions/Functions"

const TABLE_IMAGE = "/assets/img/table.svg";
const reservedtable = "/assets/img/reservedtable.svg";
const reservedtablespilt = "/assets/img/reservedtablespilt.svg";
const Occupied = "/assets/img/Occupied.svg";
const occupiedsplit = "/assets/img/occupiedsplit.svg";
const TABLE_HOVER_IMAGE = "/assets/img/tablehover.svg";
const TABLE_SPLIT_IMAGE = "/assets/img/tablesplit.svg";

// const list = [
//     {
//         id: 12,
//         name: "T-12",
//         branch_id: 2,
//         branch_name: "Pos Karachi",
//         capacity: "6",
//         floor_id: 2,
//         floor: {
//             id: 2,
//             name: "first",
//             status: "1",
//             slug: "aih-1748500489-first",
//             created_at: "2025-04-22T10:09:01.000000Z",
//             updated_at: "2025-04-22T10:09:01.000000Z"
//         },
//         is_color: "",
//         is_merge: 0,
//         is_reserved: 0,
//         is_split: 0,
//         slug: "",
//         status: "1",
//         updated_at1: "2025-08-01T14:06:58.000000Z"
//     },
//     {
//         id: 12,
//         name: "T-12",
//         branch_id: 2,
//         branch_name: "Pos Karachi",
//         capacity: "6",
//         floor_id: 2,
//         floor: {
//             id: 2,
//             name: "first",
//             status: "1",
//             slug: "aih-1748500489-first",
//             created_at: "2025-04-22T10:09:01.000000Z",
//             updated_at: "2025-04-22T10:09:01.000000Z"
//         },
//         is_color: "",
//         is_merge: 0,
//         is_reserved: 0,
//         is_split: 0,
//         slug: "",
//         status: "1",
//         updated_at1: "2025-08-01T14:06:58.000000Z"
//     },
//     {
//         id: 12,
//         name: "T-12",
//         branch_id: 2,
//         branch_name: "Pos Karachi",
//         capacity: "6",
//         floor_id: 2,
//         floor: {
//             id: 2,
//             name: "first",
//             status: "1",
//             slug: "aih-1748500489-first",
//             created_at: "2025-04-22T10:09:01.000000Z",
//             updated_at: "2025-04-22T10:09:01.000000Z"
//         },
//         is_color: "",
//         is_merge: 0,
//         is_reserved: 0,
//         is_split: 0,
//         slug: "",
//         status: "1",
//         updated_at1: "2025-08-01T14:06:58.000000Z"
//     },
//     {
//         id: 13,
//         name: "T-13",
//         branch_id: 2,
//         branch_name: "Pos Karachi",
//         capacity: "4",
//         floor_id: 2,
//         floor: {
//             id: 2,
//             name: "first",
//             status: "1",
//             slug: "aih-1748500489-first",
//             created_at: "2025-04-22T10:09:01.000000Z",
//             updated_at: "2025-04-22T10:09:01.000000Z"
//         },
//         is_color: "blue",
//         is_merge: 1,
//         is_reserved: 1,
//         is_split: 1,
//         slug: "",
//         status: "1",
//         updated_at1: "2025-08-01T14:06:58.000000Z"
//     }
// ];


const TableLayoutWithBg = ({
    tables,
    tablefloor,
    selectTable,
    multiSelect,
    loading,
    handleTableMulitpleSelect,
    handleTableSelect,
}) => {
    const [hoveredId, setHoveredId] = useState(null);
    const getTableImage = (table) => {
        const isSelected = Object.keys(selectTable).includes(String(table?.id));
        const isHovered = hoveredId === table?.id;
        const isSplit = table?.is_split == 1;
        const isReserved = table?.is_reserved && table?.is_reserved === 1;
        const isOccupied = table?.is_reserved && table?.is_reserved === 2;

        // 1. Occupied
        if (isOccupied) {
            return isSplit ? occupiedsplit : Occupied;
        }

        // 2. Reserved
        if (isReserved) {
            return isSplit ? reservedtablespilt : reservedtable;
        }

        // 3. Split + (Hovered or Selected)
        if (isSplit && (isHovered || isSelected)) {
            return TABLE_SPLIT_IMAGE;
        }

        // 4. Normal (Hovered or Selected)
        if (isHovered || isSelected) {
            return TABLE_HOVER_IMAGE;
        }

        // 5. Default
        return isSplit ? TABLE_SPLIT_IMAGE : TABLE_IMAGE;
    };

    const handleMouseEnter = (id) => setHoveredId(id);
    const handleMouseLeave = () => setHoveredId(null);


    const handleSelectTable = (table, index) => {
        if ((table.is_split === 1 ? table.is_reserved === 2 : (table?.is_reserved && table?.is_merge)) || loading) {
            return;
        } else {
            multiSelect ? handleTableMulitpleSelect(table, index) : handleTableSelect(table, index)
        }
    }

    const getTableTooltip = (table) => {
        const isHovered = hoveredId === table?.id;
        if (table.is_split == 1 && isHovered) {
            if (table.is_reserved === 2) return "Table split & reserved";
            if (table.is_reserved === 1) return "Table split and half reserve";
            if (table?.is_split) return "Table split";
        } else {
            if (table?.is_merge && table?.is_reserved && isHovered) return "Table merged & reserved";
            if (table?.is_merge && isHovered) return "Table merged";
            if (table.is_reserved && isHovered) return "Table reserved";
        }
        return null;
    };



    return (
        <div className="table-grid dine-in-table-layout">
            {tables?.map((table, index) => tablefloor && parseInt(table?.floor_id) === parseInt(tablefloor?.id) && (
                // {list?.map((table, index) => (
                <div
                    key={index}
                    className={`table-box 
                    ${Object.keys(selectTable).includes(String(table?.id)) && (table?.is_reserved != 1 && table?.is_reserved != 2) ? "table-selected" : ""}
                    ${Object.keys(selectTable).includes(String(table?.id)) && (table?.is_reserved == 1) ? "table-selected-reserved" : ""}
                    ${(hoveredId == table?.id) && (table?.is_reserved != 1 && table?.is_reserved != 2) ? "table-hoverd" : ""}
                    ${(table?.is_reserved) ? "table-reserved" : ""}
                    ${(table?.is_reserved === 2 || loading) ? "disable_table table-Occupied" : ""}
                    `}
                    onMouseEnter={() => handleMouseEnter(table.id)}
                    onMouseLeave={handleMouseLeave}
                    onClick={() => handleSelectTable(table, index)}
                >
                    <img
                        src={getTableImage(table)}
                        alt={table.label}
                        className="table-image"
                        style={{ width: "145px", height: "135px" }}
                    />
                    {table?.is_split === 1 ?
                        <div className="table-label table-label-split">
                            <div className="">{table?.name}A</div>
                            <div className="">{table?.name}B</div>
                        </div>
                        :
                        <div className="table-label">{table?.name}</div>
                    }
                    {/* Tooltip */}
                    {getTableTooltip(table) && (
                        <span className="table-tooltip-box-dine">{getTableTooltip(table)}</span>
                    )}
                    
                    {
                        table.is_reserved === 2 || table.is_reserved === 1 ?
                            <span className="reservation_time">Occ.from {getReseredTime(table && table.updated_at1)}</span>
                            :
                            ""
                    }
                </div>
            ))}
        </div>
    );
};

export default TableLayoutWithBg;
